import { LoginFormContainer } from "../../features/auth/components/LoginForm";

const Login = ({ mobile = false }: { mobile?: boolean }) => {
  return <LoginFormContainer mobile={mobile} />;
};

export default Login;
